module.exports = __webpack_public_path__ + "static/media/4-1.1b48c91b.png";